import React from 'react';
import PaymentConfirm from './PaymentConfirm';
import PaymentConfirmation from './PaymentConfirmation';
import numeral from 'numeral';
import MultiPaymentInformation from './MultiPaymentInformation';
import SinglePaymentInformation from './SinglePaymentInformation';
import { Header } from 'semantic-ui-react';

export function PaymentConfirmationStep({ policies, sources, payment, paymentActions, setLoading, loading, onPaymentInformationUpdate, onPaymentComplete }) {
	return {
		subheader: null,
		content: <PaymentConfirmation policies={policies} sources={sources} payment={payment} actions={paymentActions} setLoading={setLoading} loading={loading} onPaymentInformationUpdate={onPaymentInformationUpdate} onPaymentComplete={onPaymentComplete} />,
		showBack: () => false,
		showCancel: () => false,
		alternateContinueButtonText: 'Close'
	};
}

export function PaymentInformationStep({ payment, policies, onPaymentInformationUpdate, selectedTotalAmount, singlePaymentRef, step, setStep, paymentActions, isRecurring, allowMultipleEmailAddresses, defaultEmailAddress, setLoading, onCancel, bypassAmountChecks, bypassEmailAddressCheck, emailAddressOptions, hidePaymentOption }) {
	const _paymentInformationStep = {
		subheader: 'Submit Payment Information'
	};

	const hasBalance = (policies || []).some(p => p.isPartOfAccountBill ? (p.accountOutstandingBalance > 0 || p.accountPayInFull > 0) : (p.outstandingBalance > 0 || p.payInFullAmount > 0));
	
	if (!hasBalance && !bypassAmountChecks) {
		//this is for one time payments
		_paymentInformationStep.content = (
			<React.Fragment>
				<Header as='h1' content='You currently have a $0 balance.' textAlign='center' />
				<Header as='h1' content='If you have any questions, please call customer service at 800.477.1660.' textAlign='center' />
			</React.Fragment>
		);
		_paymentInformationStep.showBack = () => false;
		_paymentInformationStep.showCancel = () => false;
		_paymentInformationStep.alternateContinueButtonText = 'Close';
		_paymentInformationStep.onContinue = () => onCancel();

	} else if (payment.settings.allowSplitPayments && (payment.settings.numberOfPoliciesToAllowOnSplitPayments === 0 || policies.length <= payment.settings.numberOfPoliciesToAllowOnSplitPayments)) {
		_paymentInformationStep.content = <MultiPaymentInformation payment={payment} policies={policies} onPaymentInformationUpdate={onPaymentInformationUpdate} actions={paymentActions} allowMultipleEmailAddresses={allowMultipleEmailAddresses} defaultEmailAddress={defaultEmailAddress} setLoading={setLoading} bypassEmailAddressCheck={bypassEmailAddressCheck} emailAddressOptions={emailAddressOptions} />;
		_paymentInformationStep.getErrors = context => {
			const hasAtleastOneSource = context.sources.length > 0;
			const amountsAddUpToTotal = context.sources.reduce((acc, c) => acc + Object.values(c.amounts).reduce((acc2, v) => acc2 + v, null), null) === selectedTotalAmount;

			const errors = [];
			if (!bypassEmailAddressCheck && context.sources.some(source => source.emailAddress === null || source.emailAddress === '')) {
				errors.push('Email Address is required');
			}

			if (!hasAtleastOneSource) {
				errors.push('At least one payment method must be entered');
			}

			if (!amountsAddUpToTotal) {
				errors.push(`All payment methods must add up to ${numeral(selectedTotalAmount).format('$ 0,0.00')}`);
			}

			if (context.sources.some(source => source.fiserv && source.fiserv.addToWallet && (!source.fiserv.walletNickname || source.fiserv.walletNickname === ''))) {
				errors.push('Wallet Nickname is required');
			}

			return errors;
		};
	} else {
		_paymentInformationStep.content = <SinglePaymentInformation ref={singlePaymentRef} payment={payment} policies={policies} actions={paymentActions} onPaymentInformationUpdate={source => onPaymentInformationUpdate([source])} onContinue={() => setStep(step + 1)} isRecurring={isRecurring} allowMultipleEmailAddresses={allowMultipleEmailAddresses} defaultEmailAddress={defaultEmailAddress} setLoading={setLoading} bypassEmailAddressCheck={bypassEmailAddressCheck} emailAddressOptions={emailAddressOptions} hidePaymentOption={hidePaymentOption} />;
		_paymentInformationStep.onLoad = () => singlePaymentRef.current.reset();
		_paymentInformationStep.onContinue = () => singlePaymentRef.current.continue();
		_paymentInformationStep.getErrors = context => {
			const errors = [];

			if (!bypassEmailAddressCheck && context.sources.some(source => source.emailAddress === null || source.emailAddress === '')) {
				errors.push('Email Address is required');
			}

			if (context.singlePaymentRef.current && !context.singlePaymentRef.current.isValid()) {
				errors.push('Payment Information is not valid');
			}

			if (context.sources.some(source => source.fiserv && source.fiserv.addToWallet && (!source.fiserv.walletNickname || source.fiserv.walletNickname === ''))) {
				errors.push('Wallet Nickname is required');
			}

			return errors;
		};
	}

	return _paymentInformationStep;
}

export function PaymentConfirmStep({ policies, sources, hidePaymentOption, paymentActions }) {
	return {
		subheader: 'Confirm Payment Information',
		content: <PaymentConfirm policies={policies} sources={sources} hidePaymentOption={hidePaymentOption} actions={paymentActions} />,
		alternateContinueButtonText: 'Confirm'
	};
}
